/**
 * URL publique d'un produit sur la vitrine (Twig).
 * Aligné sur Web\Product\ProductViewFactory::pathFor().
 */

const APP_ORIGIN = process.env.REACT_APP_PUBLIC_URL || process.env.REACT_APP_APP_URL || 'http://app.local.dev:8080';

const storefrontOrigin = () => APP_ORIGIN.replace(/\/$/, '');

export const getProductPublicPath = (product) => {
  if (product?.id == null || product.id === '') {
    return null;
  }

  const slug = typeof product.slug === 'string' ? product.slug.trim() : '';
  const segment = slug !== '' ? slug : `produit-${product.id}`;

  return `/produit/${encodeURIComponent(segment)}`;
};

export const getProductPublicUrl = (product) => {
  const path = getProductPublicPath(product);
  if (path === null) {
    return null;
  }

  return `${storefrontOrigin()}${path}`;
};
